import s from './CardListing.module.scss';

const CardListing = ({ id="", heading, cards }) => {
    // console.log({cards, heading})
    return <section className={s.root} id={id}>
        <div className={s.container}>
            <h2 className={s.heading}>{heading}</h2>
            <div className={s.cardList}>
                {cards.map((card, index) => (
                    <div className={s.card} key={index}>
                        <div className={s.cardImage}>
                            <img src={card.fields.image?.url} alt={card.fields.label || card.fields.title} />
                        </div>
                        <div className={s.cardContent}>
                            <h3 className={s.cardTitle}>{card.fields.title}</h3>
                            <p className={s.cardDescription}>{card.fields.description}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    </section>
}

export default CardListing;